export const staking_list = [
  {
    "id": 0,
    "symbol": "STAR",
    "address": "0x8489f4554790F5A103F2B0398537eAEe68B73884",
    "poolId" : 0,
  },
  // {
  //   "id": 1,
  //   "symbol": "DOT",
  //   "address": "0xFFfFfFffFFfffFFfFFfFFFFFffFFFffffFfFFFfF",
  //   "poolId" : 9,
  // }
]
